import React, { useEffect } from 'react';
import { withAppContext } from 'src/store/initAppContext';
import styled, { css, withTheme } from 'styled-components';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { theme } from 'styled-tools';
import config from 'src/config/config';
import PlaceholderImage from 'src/components/Placeholder';

function AviatorIplPromoFun88(props: any) {
    const { theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const terms = [
        <>Valid From <strong>1 March to 31st May 2026.</strong></>,
        <>Must Launch <strong>Aviator game to claim free bets.</strong></>,
        <>Credited Free Bets Valid For <strong>48 hours only.</strong></>,
        <>Only Winnings From Free Bets Are Credited To Wallet.</>,
        <>Aviator Free Bets Are Distributed Randomly.</>,
        <>Limited To <strong>first 10,000 players per week.</strong></>,
        <>Cannot Be Combined With Other Promotions.</>,
        <>General Brand Terms & Conditions Apply.</>,
    ];

    return (
        <>
            <InformationWrapper>
                <HeaderSection>
                    <SmallTitle>Bet On IPL, Get 3x Aviator Free Bets</SmallTitle>

                    <MainTitle>
                        WIN UP TO <strong>3x YOUR IPL BET ON AVIATOR EVERY SUNDAY!</strong> <br /> HIGHER YOUR BET, HIGHER YOUR FREE BET.
                    </MainTitle>

                    <RibbonWrapper>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.AviatorRibbon}`}
                            alt="Aviator Ribbon"
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                    </RibbonWrapper>
                </HeaderSection>

                <Container>
                    <SectionHeading>How To Claim</SectionHeading>
                    <ClaimGrid>
                        <BigCard>
                            <StepNumber>1</StepNumber>
                            <CardTextWrap>
                                <h3>Bet On</h3>
                                <p>
                                    Bet On <strong>IPL Matches Via
                                    <br />
                                    Sportsbook, Premium
                                    <br />
                                    Sportsbook, Saba
                                    <br />
                                    Sports, Or Exchange.</strong>
                                </p>
                            </CardTextWrap>
                        </BigCard>

                        <RightCards>
                            <SideCard $propsFreeBet>
                                <StepNumber>2</StepNumber>
                                <SideCardContent>
                                    <TextArea>
                                        <h3>Free Bets</h3>
                                        <p>Receive <strong>Aviator Free Bets</strong> Every Sunday.</p>
                                    </TextArea>
                                </SideCardContent>
                            </SideCard>

                            <SideCard $propsWinUpto>
                                <StepNumber>3</StepNumber>
                                <SideCardContent>
                                    <TextArea>
                                        <h3>Win Up To 3x</h3>
                                        <p><strong>Win Up To 3x</strong> Your IPL Bet Amount On Aviator Free Bets.</p>
                                    </TextArea>
                                </SideCardContent>
                            </SideCard>

                            <SideCard $propsGHigherBet>
                                <StepNumber>4</StepNumber>
                                <SideCardContent>
                                    <TextArea>
                                        <h3>Higher Your Bet</h3>
                                        <p>Higher Your Bet → <strong>Higher Your Aviator Free Bet</strong>.</p>
                                    </TextArea>
                                </SideCardContent>
                            </SideCard>
                        </RightCards>
                    </ClaimGrid>
                </Container>

                <Container>
                    <TermsHeading>Terms & Conditions</TermsHeading>
                    <TermsList>
                        {terms.map((term, index) => (
                            <TermItem key={index}>
                                <span>✦</span>
                                <p>{term}</p>
                            </TermItem>
                        ))}
                    </TermsList>
                </Container>
            </InformationWrapper>

        </>
    );
}

export default withTheme(withAppContext(AviatorIplPromoFun88));

const InformationWrapper = styled.div`
    width: 100%;
    height: auto;
    padding: 1rem 0 5rem 0;
    gap: 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    color: #444;
    background-color: #EBEBEB;

    strong {
        font-family: 'Inter-Bold';
    }
`;

const Container = styled.div`
    width: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    padding: 1.5rem 1.5rem;
    border-radius: 8px;
`;

const HeaderSection = styled.div`
    width: 80%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    background-color: #fff;
    padding: 2.5rem 0;
    padding-bottom: 0;
    border-radius: 8px;
    position: relative;
`;

const SmallTitle = styled.p`
    margin: 0;
    color: #F00;
    font-size: 18px;
    font-family: 'Inter-Bold';
    line-height: 1.2;
`;

const MainTitle = styled.h1`
    margin: 18px 0 0;
    font-size: 22px;
    line-height: 1.45;
    font-family: 'Inter';
    letter-spacing: 0.3px;
    text-transform: uppercase;
    font-weight: 100;
`;

const RibbonWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: -3%;

    img {
        width: 100%;
        max-width: 100%;
        display: block;
    }
`;

const SectionHeading = styled.h2`
    margin: 1rem 0 1.8rem;
    color: #F00;
    font-size: 20px;
    font-family: 'Inter-Bold';
    text-align: center;
`;

const ClaimGrid = styled.div`
    width: 100%;
    max-width: 900px;
    display: grid;
    grid-template-columns: 1fr 1.9fr;
    gap: 16px;
    align-items: stretch;

    @media (max-width: 900px) {
        grid-template-columns: 1fr;
        padding: 0 1rem;
    }
`;

const GlassCard = `
    position: relative;
    border-radius: 15px;
    border: 1.5px solid rgb(200 200 200);
    backdrop-filter: blur(7.5px);
    overflow: hidden;
`;

const BigCard = styled.div`
    ${GlassCard};
    min-height: 328px;
    padding: 22px 22px 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.AviatorFreeBetsWthIPLBetsBetOneBg")}) #ebebeb;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
`;

const RightCards = styled.div`
    display: flex;
    flex-direction: column;
    gap: 18px;
`;

const SideCard = styled.div<{ $propsFreeBet?: boolean, $propsWinUpto?: boolean, $propsGHigherBet?: boolean }>`
    ${GlassCard};
    min-height: 96px;
    padding: 18px 34% 18px 14px;
    display: flex;
    align-items: center;
    
    ${(props) => props.$propsFreeBet && css`
        background: url(${config.imageV3Host}/static/cashsite/${theme("image.AviatorFreeBetsWthIPLBetsFreeBetsBg")}) #ebebeb;
    `}

    ${(props) => props.$propsWinUpto && css`
        background: url(${config.imageV3Host}/static/cashsite/${theme("image.AviatorFreeBetsWthIPLBetsWinUptoBg")}) #ebebeb;
    `}

    ${(props) => props.$propsGHigherBet && css`
        background: url(${config.imageV3Host}/static/cashsite/${theme("image.AviatorFreeBetsWthIPLBetsHigherYourBetBg")}) #ebebeb;
    `}

    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
`;

const StepNumber = styled.div`
    position: absolute;
    top: 18px;
    left: 18px;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    border: 1px solid #444;
    background: #444;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    z-index: 2;
    color: #fff;
`;

const CardTextWrap = styled.div`
    padding-left: 58px;
    padding-top: 4px;

    h3 {
        margin: 0 0 8px;
        font-size: 24px;
        font-family: 'Inter-Bold';
    }

    p {
        margin: 0;
        font-size: 16px;
        line-height: 1.45;
        font-weight: 600;
    }
`;

const SideCardContent = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 18px;
    padding-left: 58px;
`;

const TextArea = styled.div`
    h3 {
        margin: 0 0 6px;
        font-size: 18px;
        font-family: 'Inter-Bold';
    }

    p {
        margin: 0;
        font-size: 16px;
        line-height: 1.35;
        font-weight: 500;
    }
`;

const TermsHeading = styled.h2`
    margin: 1rem 0 1.8rem;
    color: #F00;
    font-size: 20px;
    font-family: 'Inter-Bold';
    text-align: center;
`;

const TermsList = styled.ul`
    width: 100%;
    max-width: 535px;
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

const TermItem = styled.li`
    width: 100%;
    background: #EBEBEB;
    min-height: 36px;
    display: flex;
    align-items: center;
    gap: 3px;
    padding: 8px 30px;
    text-transform: capitalize;
    box-sizing: border-box;

    span {
        font-size: 14px;
        flex: 0 0 16px;
    }

    p {
        margin: 0;
        font-size: 16px;
        line-height: 1.35;
        font-weight: 500;
    }
`;